import { Text } from "../../Components/atoms/Typography/Text/Text";
import { ActionButton } from "../../Components/molecules/ActionButton/ActionButton";

export const getColumns = (t, clickHandler) => {
  const formatPhoneNumber = (phoneNumber) => {
    // Format the phone number
    const formattedNumber = phoneNumber.replace(
      /(\d{2})(\d{4})(\d{4})/,
      "$1 $2 $3",
    );

    return formattedNumber;
  };
  let columndata = [
    {
      fieldtext: t("common:table-field.patient-id"),
      field: "patientCode",
      width: "180",
      textAlign: "Left",
    },
    {
      fieldtext: t("common:table-field.name"),
      field: "fullName",
      width: "180",
      textAlign: "Left",
    },
    {
      fieldtext: t("common:form.email"),
      field: "email",
      width: "180",
      textAlign: "Left",
    },
    {
      fieldtext: t("common:table-field.mobile-no"),
      field: "phoneNumber",
      width: "180",
      textAlign: "Left",
      enableGroupByFormat: true,
      template: (props) => {
        return (
          <span>{`${props.phoneNumberDialCode} ${formatPhoneNumber(
            props.phoneNumber,
          )}`}</span>
        );
      },
    },
    {
      fieldtext: t("common:table-field.created-date"),
      field: "createDate",
      width: "180",
      textAlign: "Left",
      enableGroupByFormat: true,
    },
    {
      fieldtext: t("common:table-field.actions"),
      field: "actions",
      width: "88px",
      textAlign: "Left",
      allowSorting: false,
      headerTextAlign: "Left",
      template: (props) => {
        return (
          <ActionButton
            clickHandler={(e) => clickHandler(e, props)}
            Options={[
              {
                id: 5,
                element: (
                  <Text
                    text={t("glossary:auth.reset-otp-count.reset-otp-count")}
                    color={"blue.primaryBlue"}
                  />
                ),
              },
            ]}
          />
        );
      },
    },
  ];
  return columndata;
};
